<template>
	<el-dialog :visible.sync="selfVisible" :width="width" :close-on-click-modal="false" :title="title" @closed="close">
		<component :is="component" :params="params" :close="closeEvent"/>
	</el-dialog>
</template>

<script>
export default {
	name:'com-dialog',
	props:{
		visible:{default:false},
		width:{default:'1200px'},
		title:{default:'详情'},
		component:{},
		params:{},
		closeEvent:{}
	},
	data(){
		return {
			selfVisible:false,
		};
	},
	watch:{
		selfVisible(val){
			this.$emit('update:visible',val);
		},
		visible(val){
			this.selfVisible=val;
		}
	},
	mounted(){},
	methods:{
		close(){
			this.$emit('close');
		}
	},
}
</script>

<style lang="scss">
.el-dialog__header{
	background:#FAFAFA;border-bottom:1px solid #EBEEF5;padding-top:10px;
	.el-dialog__title{font-size:16px;}
	.el-dialog__headerbtn{top:15px;}
}
.el-drawer__header{
	background:#FAFAFA;border-bottom:1px solid #EBEEF5;padding:10px 20px;
	.el-dialog__title{font-size:16px;}
	.el-dialog__headerbtn{top:15px;}
}
.el-drawer__body{
	padding:30px 20px;
}
</style>